import CookieService from './cookieService';
export const cookieService = new CookieService();
